import { TransitionStartEvent, TransitionEndEvent, EnterAnimationStartEvent } from '@mockly/events'
import Swup from 'swup'

class PageTransition {
  constructor() {
    this.init();
  }

  init() {
    this.swup = new Swup({
      containers: ['#main'],
    })

    this.swup.hooks.on('visit:start', () => {
      window.dispatchEvent(new TransitionStartEvent())
    })

    this.swup.hooks.on('visit:end', () => {
      window.dispatchEvent(new TransitionEndEvent())

      const embeddedForms = document.querySelectorAll('.pxFormGenerator')

      const headScripts = Array.from(document.head.querySelectorAll('script')).map(script => script.src);

      const formBuilderScripts = window.hulkFormBuilder?.assets;

      Object.values(formBuilderScripts)?.forEach(script => {
        const isJavascript = script.endsWith('.js');

        if (headScripts.some(s => s === script)) return;

        if (isJavascript) {
          const newScript = document.createElement('script');
          newScript.src = script;
          
          document.head.appendChild(newScript);

          newScript.onload = () => {
            if (window.hasOwnProperty('RenderFormById')) {
              embeddedForms?.forEach(form => {
                window.RenderFormById(form.id)
              })
            }
          }
        } else {
          const newLink = document.createElement('link');
          newLink.rel = 'stylesheet';
          newLink.href = script;
          document.head.appendChild(newLink);
        }
      })

      headScripts?.forEach(script => {
        if (script?.includes('form-builder')) {
          const newScript = document.createElement('script');
          newScript.src = script;
          document.head.appendChild(newScript);
        }
      })
    })

    this.swup.hooks.on('animation:in:start', () => {
      window.dispatchEvent(new EnterAnimationStartEvent())
    })
  }
}

const pageTransition = new PageTransition()

export default pageTransition